import React from 'react';
import PropTypes from 'prop-types';
import style from '../quantQualStudentOverview.module.css';
import { LEGEND_COLORS } from '../../../reports-constants';
import HeroCard from '../../../../../components/HeroCard/HeroCard';

const studentOverviewHeroCard = ({ heroCardData, onTabChange, studentId }) => {
  const nullStateMsg = (
    <p>
      There was no student activity on recent or upcoming assignments this week.<br />
      Go to the <button role="link" onClick={() => { onTabChange('assignments'); }}>Course Planner</button> tab to set up and manage assignments.
    </p>
  );
  const modalContent = (
    <div>
      <p><b>This student completed # out of # assignments</b> represents the number of assignments in this Unit that the student completed out of the number assigned to them.</p>
      <p><b>This student scored below 60% on # out of # learning objectives</b> represents the number of learning objectives assessed in this Unit where the student answered questions correctly less than 60% of the time on their first attempt.</p>
      <p><b>Unit achievement % on completion assignments (practice/homework)</b>  represents the proportion of questions completed by the student across all assignments in this Unit that define achievement by a student completing the assignment (i.e. practice quizzes and homework assignments where students are granted multiple attempts per question).</p>
      <p><b>Unit achievement % on proficiency assignments (quizzes/tests)</b> represents the proportion of questions in this Unit that this student got correct on their first try across all assignments that define achievement by proficiency (i.e. quizzes and tests where students are granted only one attempt per question).</p>
    </div>
  );
  const modalTitle = 'Student Unit Highlights';
  const heroData = heroCardData ? [
    {
      title: 'This Student Completed',
      text: heroCardData.completedAssignments < 0 ? '—' : heroCardData.completedAssignments,
      color: LEGEND_COLORS.BLACK,
      showBottomText: true,
      bottomText: <p>Out of <b>{heroCardData.assignments}</b> Assignment{heroCardData.assignments === 1 ? '' : 's'}</p>,
    },
    {
      title: 'This Student Scored Below 60% on',
      color: LEGEND_COLORS.BLACK,
      text: (heroCardData.lowScoringLOs <= 0 && heroCardData.notStarted) ? '—' : heroCardData.lowScoringLOs,
      showBottomText: true,
      bottomText: (heroCardData.lowScoringLOs <= 0 && heroCardData.notStarted) ? <p>Learning Objectives</p> : <p>Out of <b>{heroCardData.totalLOs}</b> Learning {heroCardData.totalLOs === 1 ? 'Objective' : 'Objectives'}</p>,
      className: style.secondColumn,
    },
    {
      title: 'Unit Achievement',
      color: LEGEND_COLORS.BLACK,
      text: heroCardData.averageCompletion < 0 ? '—' : `${Math.round(heroCardData.averageCompletion * 100)}%`,
      showBottomText: true,
      bottomText: 'on Completion Assignments (Practice/Homework)',
    },
    {
      title: 'Unit Achievement',
      color: LEGEND_COLORS.BLACK,
      text: heroCardData.averageProficiency < 0 ? '—' : `${Math.round(heroCardData.averageProficiency * 100)}%`,
      showBottomText: true,
      bottomText: 'on Proficiency Assignments (Quizzes/Test)',
    },
  ] : [];

  const reportUrl = heroCardData ? `reports/type/student-unit/${studentId}/${heroCardData.id}` : '';
  return (
    <HeroCard
      className={style.qqReportCard}
      heroData={heroData}
      heroTitle={`Current Unit: ${heroCardData ? heroCardData.name : 'None'}`}
      modalTitle={modalTitle}
      modalContent={modalContent}
      showNullStateMessage={!heroCardData}
      nullStateMessage={nullStateMsg}
      buttonText="View Unit Report"
      showModuleReportButton={!!heroCardData}
      reportUrl={reportUrl}
      onTabChange={onTabChange}
    />
  );
};

studentOverviewHeroCard.propTypes = {
  heroCardData: PropTypes.object,
  onTabChange: PropTypes.func,
  showModuleReportButton: PropTypes.bool,
  studentId: PropTypes.string,
};

export default studentOverviewHeroCard;
